import { cn } from '@/lib/utils'

interface SourceHealthIndicatorProps {
  isHealthy: boolean
}

export function SourceHealthIndicator({ isHealthy }: SourceHealthIndicatorProps) {
  return (
    <span className="inline-flex items-center gap-1.5 text-sm">
      <span
        className={cn(
          'h-2 w-2 rounded-full',
          isHealthy ? 'bg-green-500' : 'bg-red-500'
        )}
      />
      {isHealthy ? 'Healthy' : 'Unhealthy'}
    </span>
  )
}
